module.exports = __webpack_public_path__ + "static/media/arrow-alt-up.2aa1a171.svg";